/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer } from '../runtime.js';

const cs_payment_information = /** @type {(inputs: {}) => string} */ () => {
	return `Informace o platbě`
};

const da_payment_information = /** @type {(inputs: {}) => string} */ () => {
	return `Betalingsoplysninger`
};

const de_payment_information = /** @type {(inputs: {}) => string} */ () => {
	return `Zahlungsinformationen`
};

const en_payment_information = /** @type {(inputs: {}) => string} */ () => {
	return `Payment information`
};

const es_payment_information = /** @type {(inputs: {}) => string} */ () => {
	return `Información de pago`
};

const fr_payment_information = /** @type {(inputs: {}) => string} */ () => {
	return `Informations de paiement`
};

const hu_payment_information = /** @type {(inputs: {}) => string} */ () => {
	return `Fizetési adatok`
};

const it_payment_information = /** @type {(inputs: {}) => string} */ () => {
	return `Informazioni di pagamento`
};

const nl_payment_information = /** @type {(inputs: {}) => string} */ () => {
	return `Betaalinformatie`
};

const pl_payment_information = /** @type {(inputs: {}) => string} */ () => {
	return `Dane płatności`
};

const pt_payment_information = /** @type {(inputs: {}) => string} */ () => {
	return `Informações de pagamento`
};

const sv_payment_information = /** @type {(inputs: {}) => string} */ () => {
	return `Betalningsinformation`
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "cs" | "da" | "de" | "en" | "es" | "fr" | "hu" | "it" | "nl" | "pl" | "pt" | "sv" }} options
* @returns {string}
*/
/* @__NO_SIDE_EFFECTS__ */
export const payment_information = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.payment_information(inputs) 
	}
	const locale = options.locale ?? getLocale()
	trackMessageCall("payment_information", locale)
	if (locale === "cs") return cs_payment_information(inputs)
	if (locale === "da") return da_payment_information(inputs)
	if (locale === "de") return de_payment_information(inputs)
	if (locale === "en") return en_payment_information(inputs)
	if (locale === "es") return es_payment_information(inputs)
	if (locale === "fr") return fr_payment_information(inputs)
	if (locale === "hu") return hu_payment_information(inputs)
	if (locale === "it") return it_payment_information(inputs)
	if (locale === "nl") return nl_payment_information(inputs)
	if (locale === "pl") return pl_payment_information(inputs)
	if (locale === "pt") return pt_payment_information(inputs)
	return sv_payment_information(inputs)
};